<script>
import { Upload } from 'ant-design-vue'

delete Upload.props.beforeUpload

export default {
  extends: Upload,
  props: {
    name: {
      type: String,
      default: 'file'
    },
    headers: {
      type: Object,
      default: () => ({
        Authorization: window.localStorage.getItem('token')
      })
    }
  },
  methods: {
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('Dozwolony format to JPG i PNG')
      }
      const isLt2M = file.size / 1024 / 1024 < 3
      if (!isLt2M) {
        this.$message.error('Zdjęcie może mieć maksymalnie 3MB.')
      }
      return isJpgOrPng && isLt2M
    }
  }
}
</script>
